import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { JourneyService } from '../../services/journey.service';
import { JourneyStepCtaComponent } from '../journey-step-cta/journey-step-cta.component';

/**
 * The one thing to do next, pulled out of the checklist and given its own call to action.
 *
 * The page used to give all twenty-one steps the same weight, which left nothing to click
 * first. Once the journey is finished the card turns into its reward state.
 */
@Component({
  selector: 'app-journey-next-step',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    LucideAngularModule,
    JourneyStepCtaComponent,
  ],
  templateUrl: './journey-next-step.component.html',
})
export class JourneyNextStepComponent {
  private journeyService = inject(JourneyService);

  /** The popup has its own single "resume" button, so it hides the per-step call to action. */
  showCta = input(true);

  nextStep = this.journeyService.nextStep;
  isComplete = this.journeyService.isComplete;

  /** Situates the step in the journey: "3 · Diminuer l'impact CO₂e des voyages". */
  phaseContext = computed(() => {
    const step = this.nextStep();

    return (
      this.journeyService
        .phases()
        .find((phase) => phase.phase === step?.phase) ?? null
    );
  });
}
